// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9fa14321","667":"294505d8","977":"3669c1e9"}[chunkId] + ".chunk.js";
};